import React from "react"

const EkycCheckboxContent = () => {
    
  const myFunction = () => {
    var dots = document.getElementById("dots")
    var moreText = document.getElementById("more")
    var btnText = document.getElementById("myBtn")

    if (dots.style.display === "none") {
      dots.style.display = "inline"
      btnText.innerHTML = "Read more"
      moreText.style.display = "none"
    } else {
      dots.style.display = "none"
      btnText.innerHTML = "Read less"
      moreText.style.display = "inline"
    }
  }

  return (
    <>
      <label htmlFor="checkboxG6" className="css-label">
        <p>
          {" "}
          I hereby give my explicit and voluntary consent to Canara HSBC
          Life Insurance Company Limited ("the
          Company") to obtain and use my Aadhaar Number to authenticate or
          complete my electronic Know Your Customer (e-KYC) requirements through
          One Time Password (OTP) received by me/ my biometrics with the Unique
          Identification Authority of India (UIDAI) in connection with the
          Proposal Form submitted by me, which will include but not limited to
          the issuance of the Insurance Policy and resultant service requests
          ("Purpose"). <span id="dots">...</span>
        </p>
        <span id="more">
          <p>
            {" "}
            I acknowledge that my Aadhaar details will be submitted to the
            Central Identities Data Repository (CIDR) for the purpose of
            authentication and that upon authentication, UIDAI may share my
            Aadhaar information in the nature of demographic information
            including my photograph with the Company as an identity and/or
            address proof for the above purpose which might be further retained
            for a period specified under applicable laws & regulations.{" "}
          </p>
          <p>
            {" "}
            I understand that (a)Apart from Aadhaar there are other alternatives
            that can be submitted as proof of identity and address (b) Aadhaar
            information shall not be used for any purpose other than those
            mentioned herein or as per requirements of law (c) Biometric details
            will not be stored by the Company and (d) Aadhaar information will
            not be shared with any third party except as provide under
            applicable law(s){" "}
          </p>
          <p>
            {" "}
            I hereby declare and confirm that all the information furnished by
            me is true correct and complete I will not hold the Company or its
            officials responsible in case of any incorrect information provided
            by me.{" "}
          </p>
        </span>
      </label>{" "}
      <span
        style={{ textDecoration: "underline" }}
        aria-hidden="true"
        onClick={myFunction}
        id="myBtn"
      >
        Read more
      </span>
      <p></p>
    </>
  )
}

export default EkycCheckboxContent
